import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getLensBrandsURL, getSTLensTypesURL,getSTLensIndexURL, getSTLensSphURL,getSTLensCylURL, getSTProductsURL, getProductByCodeURL, getMatrixQuantityURL} from '../api';
import moment from 'jalali-moment'
import { GroupBy } from "../helpers/mmg";

// initial state
export const initialState = {
  
  itemsToAddFromMatrix : [],
  submitOrderAfterCloseMatrix : false
};

// our slice
const matrixSlice = createSlice({
  name: "matrix",
  initialState,
  reducers: {
    setSTOrderLoading: (state) => {
      state.loading = true;
    },
    addItemsFromMatrix : (state, { payload }) => {

      console.log(" ثبت از ماتریس");
      console.log(payload);

      //var newItem = { RowId : payload.selectedRowId , selectedProductId : payload.selectedProductId, selectedProductCode : payload.selectedProductCode, selectedProductId : payload.selectedProductId , Quantity : payload.selectedQuantity , Fee : payload.selectedFee  };
      //console.log(newItem);
      if(parseFloat(payload.selectedQuantity) <= 0){
        if (state.itemsToAddFromMatrix.find(e => e.selectedProductId.toString() === payload.selectedProductId.toString())){
         // selectedProductId
         state.itemsToAddFromMatrix = state.items.filter(e => e.selectedProductId.toString() !== payload.selectedProductId.toString());
        }
      }else{
        if (state.itemsToAddFromMatrix.find(e => e.selectedProductId.toString() === payload.selectedProductId.toString())) {

          state.itemsToAddFromMatrix.find(e => e.selectedProductId.toString() === payload.selectedProductId.toString()).selectedQuantity = payload.selectedQuantity;
  
        }else{
          
          state.itemsToAddFromMatrix.push(payload);
          
        }
      }
      
      
    },
    deleteAllMatrix: (state, { payload }) => {
      state.itemsToAddFromMatrix = [];
      state.submitOrderAfterCloseMatrix = false;
    },
    submitOrderAfterCloseMatrix : (state, { payload }) =>{
      state.submitOrderAfterCloseMatrix = true;
    }
  },
});

// export the actions
export const { 
  addItemsFromMatrix,
  setSTOrderLoading,
  deleteAllMatrix,
  submitOrderAfterCloseMatrix

} = matrixSlice.actions;

// export the selector (".items" being same as in slices/index.js's "items: something")
export const stOrderItemsSelector = (state) => state.items;

// export the default reducer
export default matrixSlice.reducer;
